export const API_URL = process.env.REACT_APP_API_URL || "Y";
export const CAMPAIGN_ID = "01FBMTKG10XCHRYA7HFB6E32TT";
export const USER_ID = "admin@sen.kim";
